import React, { FC, useMemo } from 'react';

import { useAssetInputStyle } from './LeverageInput.style';
import { LeverageInputTooltip } from './LeverageInputTooltip';

import { formatWithCommas, formatWithMaxPrecision } from '@/shared/utils/helpers';
import { NumericInput } from '@/widgets/NumericInput';
import { cn } from '@/shared/lib/tailwind-merge';
import { AssetWithIcon } from '@/shared/ui';

type AssetInputSupplyProps = {
    tokenSymbol: string;
    maxBorrow: string;
    value?: string;
    setValue: (value: any) => void;
    disabled?: boolean;
    classes?: Partial<Record<AssetInputSupplyClasses, string>>;
    decimals: number;
    apy?: string;
    interestClaimable?: string;
    totalPosition?: string;
    interestAccrued?: string;
    totalDeposited?: string;
    totalBorrowed?: string;
    error: boolean;
};

type AssetInputSupplyClasses = 'root';

export const LeverageInput: FC<AssetInputSupplyProps> = ({
    value,
    setValue,
    tokenSymbol,
    classes,
    disabled,
    decimals,
    maxBorrow,
    apy,
    error,
}) => {
    const baseClasses = useAssetInputStyle();

    const handleAmountChange = (value: string | null) => {
        setValue(value);
    };

    const handleMaxClick = () => {
        setValue(maxBorrow);
    };

    const formatMaxBorrow = useMemo(() => {
        const plainDecimal = Number(maxBorrow).toFixed(decimals);

        return formatWithMaxPrecision(plainDecimal, decimals);
    }, [maxBorrow, decimals]);

    return (
        <>
            <div
                className={cn(baseClasses.root, classes?.root || '', {
                    ['error']: error,
                })}
            >
                <div className={baseClasses.footer}>
                    <div className={`${baseClasses.input} [&_input]:p-0 [&_input]:h-[28px]`}>
                        <NumericInput
                            value={value!}
                            onRawValueChange={async (rawValue) => {
                                await handleAmountChange(rawValue);
                            }}
                            decimals={decimals}
                            disabled={disabled}
                        />
                    </div>
                    <div className={baseClasses.inputWrapper}>
                        <AssetWithIcon
                            assetName={tokenSymbol || ''}
                            textClassName={baseClasses.assetName}
                        />
                    </div>
                </div>
            </div>
            <div className={baseClasses.infoWrapper}>
                <div className={baseClasses.balanceWrapper}>
                    <LeverageInputTooltip apy={apy} handleMaxClick={handleMaxClick} />
                    <div className={baseClasses.title}>
                        {'Max Available:'}&nbsp;
                        <span className={baseClasses.textBtn} onClick={handleMaxClick}>
                            {' '}
                            {formatWithCommas(formatMaxBorrow)} {tokenSymbol}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
};
